'use client'

import React from 'react'

type VideoBannerProps = {
  content: any
}

const VideoBanner: React.FC<VideoBannerProps> = ({
  content,
}: VideoBannerProps) => {
  return (
    <div className="mb-[100px] h-[500px] w-full">
      <video className="h-full w-full object-cover" autoPlay muted loop>
        <source
          src={content?.video?.file?.url}
          type={content?.video?.file?.contentType}
        />
      </video>
    </div>
  )
}

export { VideoBanner }
